export * from './user-avatar-updated.message';
export * from './user-avatar-updated-message-template.component';